import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/data/categories';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=A%20wide%20editorial%20flat%20lay%20of%20assorted%20streetwear%20merchandise%20including%20sneakers%20a%20denim%20jacket%20a%20cap%20and%20a%20backpack%20scattered%20artistically%20on%20a%20warm%20rust%20orange%20studio%20backdrop%20with%20soft%20directional%20light%20rich%20texture%20vibrant%20modern%20fashion%20aesthetic%20high%20detail&width=1600&height=900&seq=hero-usfans-02&orientation=landscape&nocache=true';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="USFans spreadsheet fashion and merchandise collection"
          title="USFans Spreadsheet fashion and merchandise collection"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/45" />
      </div>

      <div className="relative mx-auto flex min-h-[420px] w-full max-w-7xl flex-col items-center justify-center px-4 py-20 text-center md:min-h-[600px] md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
          <i className="ri-shield-check-line" />
          {t('home.hero.badge')}
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          {t('home.hero.title')}
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-50/90 md:text-lg">
          {t('home.hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:gap-4">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center rounded-md bg-primary-500 px-6 py-3 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap sm:w-auto"
          >
            {t('home.hero.ctaMain')}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center rounded-md bg-accent-500 px-6 py-3 text-base font-semibold text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap sm:w-auto"
          >
            {t('home.hero.ctaBuy')}
          </a>
          <Link
            to="/usfans-spreadsheet-guide"
            className="inline-flex w-full items-center justify-center rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-base font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 whitespace-nowrap sm:w-auto"
          >
            {t('home.hero.ctaGuide')}
          </Link>
        </div>

        <p className="mt-8 text-xs text-background-50/80 md:text-sm">{t('home.hero.trust')}</p>
      </div>
    </section>
  );
}